module.exports = __webpack_public_path__ + "static/media/donation_wechat.84e04efe.jpg";